import type { LongFormContentImproverData, LongFormSection } from './types';

/**
 * Checks if a section has content
 * HINT: section converted to HTML stores content in the `content` field
 * @param section - section object
 * @returns - true if the section has content
 */
export const longFormSectionHasContent = (section: LongFormSection): boolean => {
  if (!section?.content) {
    return false;
  }

  return section.content.length > 0;
};

export const getRecomposeModeFromLongFormGenerationInfo = (generationInfo: {
  contentImproverData: LongFormContentImproverData;
}) => {
  return generationInfo?.contentImproverData?.recomposeMode || null;
};
